<template>
    <div class="notice">
        <div class="header">
            <div class="back" @click="() => {$router.go(-1)}">
                <img src="../../assets/notice/back.png" />返回
            </div>
            <div class="user"></div>
        </div>
        <div class="logo">
            <div class="bg"></div>
        </div>
        <noticeDialog></noticeDialog>
        <!-- <div class="footer">技术支持:中联集团教育有限公司</div> -->
    </div>
</template>
<script>
export default {
    name: 'notice',
    data() {
        return {
            show: false
        }
    },
    components: {
        noticeDialog: () => import('./noticeTips.vue')
    },
    methods: {}
}
</script>
<style scoped lang="scss">
.notice{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
    *{
        box-sizing: border-box;
    }
    .header{
        height: 68px;
        padding: 0 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .back{
            font-size: 14px;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                width: 6px;
                height: 11.4px;
                margin-right: 4px;
                user-select: none;
                -webkit-user-drag: none;
            }
        }
    }
    .logo{
        height: 549px;
        width: 100%;
        background-image: url('https://img.js.design/assets/img/6343ec75025a07c7c97ea2a6.png#76d4c986e2b3a6a8b9e1ec86bdd3c7bb');
        background-size: cover;
        position: relative;
        .bg{
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: linear-gradient(270deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.3) 51.1%, rgba(0, 0, 0, 0.45) 100%);
        }
    }
    .footer{
        font-size: 14px;
        color: rgba(0, 0, 0, 1);
        text-align: center;
        position: absolute;
        bottom: 20px;
        width: 100%;
    }
}
</style>